module.exports = __webpack_public_path__ + "media/images/icon-business-decisions-027421bf571413c081af989f7c40aab6.svg";